import React from "react";
import { createRoutingObject } from "@akj-dev/affinity-suite";
import { Home } from "./screens/Home";

export const routes = createRoutingObject(
  [
    {
      path: "/",
      title: "Dashboard",
      subject: <Home />
    }
  ],
  "/billing"
);
